import { IDriver, IListOption } from "../classes/Domain";
import React from "react";
import { ListGroup, Collapse } from "react-bootstrap";
import Utilities from "../classes/Utilities";
import Select from 'react-select'
import { Rifm } from 'rifm';
import { Alert } from 'react-bootstrap';
import ValidatableFormGroup from "./ValidatableFormGroup";
import { validationUtils, IValidationFailure } from "../validation/Validation";
import StateList from "./StateList";
import SelectList from "./SelectList";
import { FULL_QUOTE_STEPS, slectColourStyles } from "../AppConstants";
import QuoteStepBase from './../components/QuoteStepBase';
import { IQuoteStepComponentProps } from "./../components/interfaces";


interface IProps extends IQuoteStepComponentProps {
    disabled: boolean,
    driverOptions: Array<IListOption>,
    genderOptions: Array<IListOption>,
    maritalOptions: Array<IListOption>,
    licenseStatusOptions: Array<IListOption>,
    relationshipOptions: Array<IListOption>,
    additionalDriver: IDriver,
    driverIndex: number,
    driverStatus: string,
    licenseStatus: string,
    gender: string,
    maritalStatus: string,
    relationshipLevel: string,
    getListSelectOption(driverIndex: number, options: Array<IListOption>, property: string, value: string): IListOption,
    onDriverStatusChange(driver: IDriver, driverIndex: number, option: IListOption | null): void,
    onDriverDataChange(value: any, driver: IDriver, driverIndex: number, property: string): void
}

interface IState {
    key: string,
    errors?: Array<IValidationFailure> | null;
}

class AdditionalDriver extends QuoteStepBase<IProps, IState>
{
    constructor(props: IProps) {
        super(props);

        this.state = {
            key: Utilities.uniqueId() + "_" + this.props.additionalDriver.id,
            errors: null
        }
    }

    componentDidMount() {
        this.setState({ ...this.state, errors: null });

        var uid = FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS + "_" + this.props.additionalDriver.id;

        validationUtils.subscribeToValidationFailure(uid,
            validationData => {
                this.setState({ ...this.state,  errors: validationData });
            });
    }

    componentWillUnmount() {
        var uid = FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS + "_" + this.props.additionalDriver.id;

        validationUtils.unsubscribeFromValidationFailure(uid);
    }

    render() {
        return (
            <ListGroup.Item key={this.state.key + "_listGroup"}>
                <label className="left-cell">
                    <span>
                        {this.props.additionalDriver.firstName} {this.props.additionalDriver.lastName}
                    </span>
                </label>
                <label className="right-cell">
                    <Select
                        key={this.state.key + "_selectDriverStatus"}
                        options={this.props.driverOptions}
                        value={this.props.getListSelectOption(this.props.driverIndex, this.props.driverOptions, "driverStatus", this.props.driverStatus)}
                        onChange={(v) => this.props.onDriverStatusChange(this.props.additionalDriver, this.props.driverIndex, v ? { label: v["label"], value: v["value"] } : null)}
                        isClearable={false}
                        styles={slectColourStyles}
                    />
                </label>
                <Collapse in={this.props.getListSelectOption(this.props.driverIndex, this.props.driverOptions, "driverStatus", this.props.driverStatus)?.value === "ADD"} key={this.state.key + "_add_collapse"}>
                    <div key={this.state.key + "_add_div"}>
                        <Alert variant={"success"}>
                            <h5 className="text-center">Driver Info</h5>
                            <ValidatableFormGroup
                                key={this.state.key + "_firstName"}
                                label="First Name"
                                className="col-left"
                                value={this.props.additionalDriver.firstName}
                                placeholder="First Name"
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "firstName")}
                                onChange={(e) => { this.props.onDriverDataChange(e.target.value, this.props.additionalDriver, this.props.driverIndex, "firstName"); validationUtils.setValidationErrorFor(this.state.errors, "firstName", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />

                            <ValidatableFormGroup
                                key={this.state.key + "_lastName"}
                                label="Last Name"
                                className="col-right"
                                value={this.props.additionalDriver.lastName}
                                placeholder="Last Name"
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "lastName")}
                                onChange={(e) => { this.props.onDriverDataChange(e.target.value, this.props.additionalDriver, this.props.driverIndex, "lastName"); validationUtils.setValidationErrorFor(this.state.errors, "lastName", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />

                            <Rifm
                                key={this.state.key + "_birthDate"}
                                accept={/\d/g}
                                mask={!!this.props.additionalDriver && 10 <= this.props.additionalDriver.birthDate?.length}
                                format={Utilities.formatDate}
                                value={this.props.additionalDriver.birthDate}
                                onChange={(v) => { this.props.onDriverDataChange(v, this.props.additionalDriver, this.props.driverIndex, "birthDate") }}>
                                {({ value, onChange }) => (
                                    <ValidatableFormGroup
                                        label="Birthdate"
                                        className="col-left"
                                        placeholder="mm/dd/yyyy"
                                        value={value}
                                        validated={null !== this.state.errors}
                                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "birthDate")}
                                        onChange={(e) => { onChange(e); validationUtils.setValidationErrorFor(this.state.errors, "birthDate", "") }}
                                        pattern="[0-9]*"
                                        inputmode="numeric"
                                        disabled={this.props.additionalDriver.isExcluded}
                                    />
                                )}
                            </Rifm>

                            <SelectList
                                key={this.state.key + "_selectGender"}
                                label="Gender"
                                className="col-right"
                                selectOptions={this.props.genderOptions}
                                value={this.props.additionalDriver.gender}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "gender")}
                                onChange={(v) => { this.props.onDriverDataChange(v?.value ?? null, this.props.additionalDriver, this.props.driverIndex, "gender"); validationUtils.setValidationErrorFor(this.state.errors, "gender", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />

                            <SelectList
                                key={this.state.key + "_selectMarital"}
                                label="Marital Status"
                                className="col-left"
                                selectOptions={this.props.maritalOptions}
                                value={this.props.additionalDriver.maritalStatus}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "maritalStatus")}
                                onChange={(v) => { this.props.onDriverDataChange(v?.value ?? null, this.props.additionalDriver, this.props.driverIndex, "maritalStatus"); validationUtils.setValidationErrorFor(this.state.errors, "maritalStatus", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />

                            <SelectList
                                key={this.state.key + "_selectRelationship"}
                                label="Relationship"
                                selectOptions={this.props.relationshipOptions}
                                value={this.props.additionalDriver.relationshipLevel}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "relationshipLevel")}
                                onChange={(v) => { this.props.onDriverDataChange(v?.value ?? null, this.props.additionalDriver, this.props.driverIndex, "relationshipLevel"); validationUtils.setValidationErrorFor(this.state.errors, "relationshipLevel", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />

                            <ValidatableFormGroup
                                key={this.state.key + "_licenseNumber"}
                                label="License Number"
                                className="col-left"
                                value={this.props.additionalDriver.licenseNumber}
                                placeholder="Driver's License Number"
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "licenseNumber")}
                                onChange={(e) => { this.props.onDriverDataChange(e.target.value, this.props.additionalDriver, this.props.driverIndex, "licenseNumber"); validationUtils.setValidationErrorFor(this.state.errors, "licenseNumber", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />

                            <StateList
                                key={this.state.key + "_licenseState"}
                                label="Driver's License State"
                                className="col-right"
                                value={this.props.additionalDriver.licenseState}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "licenseState")}
                                onChange={(state) => { this.props.onDriverDataChange(state?.value ?? "", this.props.additionalDriver, this.props.driverIndex, "licenseState"); validationUtils.setValidationErrorFor(this.state.errors, "licenseState", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />

                            <SelectList
                                key={this.state.key + "_selectlicenseStatus"}
                                label="License Status"
                                className="col-left"
                                selectOptions={this.props.licenseStatusOptions}
                                value={this.props.additionalDriver.currentLicenseStatus}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "currentLicenseStatus")}
                                onChange={(v) => { this.props.onDriverDataChange(v?.value ?? null, this.props.additionalDriver, this.props.driverIndex, "currentLicenseStatus"); validationUtils.setValidationErrorFor(this.state.errors, "currentLicenseStatus", "") }}
                                disabled={this.props.additionalDriver.isExcluded}
                            />
                        </Alert>
                        </div>
                    </Collapse>
            </ListGroup.Item>
        );
    }
}

export default AdditionalDriver;